import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { Stack, Typography, CircularProgress, Button, Box } from "@mui/material";
import { styled } from "@mui/system";
import { PaymentClient } from "../../../../utilities/backend/payment";
import { useSelector } from "react-redux";
import { RootState } from "../../../../utilities/redux/store";

const Wrapper = styled(Stack)(({ theme }) => ({
    paddingTop: "40px",
    margin: "auto",
    width: 600,
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
        width: "90%",
        padding: "40px 17px 80px",
    },
}));

const AchPaymentSuccess = () => {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(true);
    const navigate = useNavigate();

    const paymentClient = new PaymentClient();

    const iswithOutAuth = useSelector((state: RootState) => state.token.token) === null;

    useEffect(() => {
        const fetchData = async () => {
            try {
                let paramsObject: Record<string, string | undefined> = {};
                searchParams.forEach((value, key) => {
                    paramsObject[key] = value;
                });

                if (Object.keys(paramsObject).length === 0) {
                    setMessage("No parameters found.");
                    setLoading(false);
                    return;
                }

                const storedRedirectUrl = localStorage.getItem("ach-payment-redirectUrl") ?? "/find";
                const storedAnonymousStates = localStorage.getItem("ach-payment-states");

                if (iswithOutAuth) {
                    paramsObject = {
                        ...paramsObject,
                        userName: localStorage.getItem("userName") ?? undefined
                    };
                }

                if (storedAnonymousStates) {
                    paramsObject = {
                        ...paramsObject,
                        ...JSON.parse(storedAnonymousStates)
                    }
                }

                const data = await paymentClient.make_bank_payment({ ...paramsObject });

                if (data.success) {
                    setIsSuccess(true);
                    setMessage("Payment successful!");

                    if (storedRedirectUrl.startsWith("/invest")) {
                        localStorage.setItem("initiateRecommendation", "true");
                    }

                    if (storedAnonymousStates) {
                        localStorage.setItem("feedback-temp-email", JSON.parse(storedAnonymousStates).email)
                    }

                    navigate(storedRedirectUrl);
                    localStorage.removeItem("ach-investment-amount");
                    localStorage.removeItem("ach-payment-redirectUrl");
                    localStorage.removeItem("ach-payment-states");
                } else {
                    setIsSuccess(false);
                    setMessage(data.message || "Payment failed.");
                }
            } catch (error) {
                setIsSuccess(false);
                setMessage("Something went wrong. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [searchParams, iswithOutAuth]);

    useEffect(() => {
        if (!isSuccess) {
            navigate("/ach-payment", { state: { errorMessage: message } });
        }
    }, [isSuccess, navigate]);

    return (
        <Wrapper alignItems="center" justifyContent="center" spacing={4}>
            <Box
                sx={{
                    position: "fixed",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    textAlign: "center",
                }}
            >
                <CircularProgress />
                <Typography
                    variant="h5"
                    sx={{ marginTop: 2, fontWeight: 600 }}
                >
                    Processing...
                </Typography>

                <Typography
                    variant="body1"
                    sx={{ marginTop: 3, color: "gray", fontWeight: 500 }}
                >
                    Please do not refresh the page or click the "Back" or "Close" button of your browser.
                </Typography>
            </Box>
        </Wrapper>
    );
};

export default AchPaymentSuccess;
